import {FC} from 'react'
import {useIntl} from 'react-intl'
import {DeliveryPath, DELIVERY_PATH_KEYS} from '../cors/_models'

/**
 * Anonymized delivery-path indicator.
 *
 * Three states the supplier needs to recognise at a glance:
 *   in_warehouse  — stock is in the FC, ships immediately      (green)
 *   pickup        — Dumyah picks up from supplier, then ships  (blue)
 *   supplier_ship — supplier delivers to FC, then we ship      (grey)
 *
 * Matches the customer-facing logic byte-for-byte; supplier sees
 * exactly what the buyer's PDP shows.
 */

type IProps = {
  path: DeliveryPath | undefined | null
  hours?: number
}

const STYLES: Record<DeliveryPath, {bg: string; color: string; border: string}> = {
  in_warehouse: {bg: '#ecfdf5', color: '#047857', border: '#d1fae5'},
  pickup: {bg: '#eff6ff', color: '#1d4ed8', border: '#dbeafe'},
  supplier_ship: {bg: '#f3f4f6', color: '#6b7280', border: '#e5e7eb'},
}

const DeliveryPathChip: FC<IProps> = ({path, hours}) => {
  const {formatMessage} = useIntl()
  if (!path) return <span className="text-muted">—</span>
  const style = STYLES[path]
  const labelKey = DELIVERY_PATH_KEYS[path]
  return (
    <span
      className="d-inline-flex align-items-center"
      style={{
        background: style.bg,
        color: style.color,
        border: `1px solid ${style.border}`,
        borderRadius: 999,
        padding: '3px 10px',
        fontSize: 11,
        fontWeight: 500,
        whiteSpace: 'nowrap',
        lineHeight: 1.3,
      }}
      data-path={path}
    >
      {formatMessage({id: labelKey})}
      {typeof hours === 'number' && hours > 0 ? (
        <span className="ms-1 text-muted" style={{fontWeight: 400}}>
          · {hours}h
        </span>
      ) : null}
    </span>
  )
}

export default DeliveryPathChip
